import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TreeComponent } from './tree.component';



@NgModule({
  declarations: [
    TreeComponent
  ],
  exports:[
    TreeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    
  ]
})
export class TreeModule { }
